/* eslint-disable max-len */
import { ChevronRightIcon, LockClosedIcon, UserCircleIcon } from '@heroicons/react/solid';
import { useIntl } from 'react-intl';
import { Profile } from 'src/types';
import env from 'src/env/index';
import Skeleton from 'react-loading-skeleton';

type Props = {
    name?: String;
    email?: String;
    isLoading: Boolean,
    isMobile?: boolean
};

const ProfileInfomation = (props: Props) => {
    const {
        email, name, isLoading, isMobile,
    } = props;
    const intl = useIntl();
    const userProfile: Profile = JSON.parse(
        localStorage.getItem('profile') ?? '{}'
    );

    return (
        <div className={[' h-35 flex flex-col md:mt-0 md:flex md:flex-row md:place-items-center justify-center xl:justify-start md:pt-4 md:pb-4 md:ml-6 md:h-full',
            (isLoading ? 'animate-pulse' : '')].join(' ') }>
            {isLoading
                && <>
                    <div className='absolute md:relative invisible md:visible border-top-bar-profile  '>
                        <Skeleton circle={true} style={{ width: '4rem', height: '4rem' }} />
                    </div>
                    <div className={['flex flex-col p-6 '].join(' ')}>
                        <div>
                            <span className='font-bold mr-1'>
                                <Skeleton
                                    baseColor='#d7d7d7'
                                    highlightColor='#c8c8c8'
                                    height={15}
                                    width={300}
                                />
                            </span>
                        </div>
                        <div className='mr-3 flex'>
                            <span className='font-bold mr-4'>
                                <Skeleton
                                    baseColor='#d7d7d7'
                                    highlightColor='#c8c8c8'
                                    height={15}
                                    width={250}
                                />
                            </span>
                            <span className='break-all'>
                            </span>
                        </div>
                        <div className='flex flex-col md:flex-row mt-3'>
                            <a href={`${env.ssoV1Url}/portal/profile`} className='flex flex-row place-items-center hover:underline gap-x-2 h-8 '>
                                <span className='flex w-4 h-4 content-center '> <UserCircleIcon className='fill-icon-grey'/> </span>
                                <span className='font-bold'>
                                    <Skeleton
                                        baseColor='#d7d7d7'
                                        highlightColor='#c8c8c8'
                                        height={15}
                                        width={150}
                                    />
                                </span>
                            </a>
                            <a href={`${env.ssoV1Url}/portal/security`} className='flex flex-row place-items-center hover:underline gap-x-2 h-8'>
                                <span className='flex w-4 h-4 content-center '> <LockClosedIcon className='fill-icon-grey'/> </span>
                                <span className='font-bold border-b border-transparent group-hover:border-black'>
                                    <Skeleton
                                        baseColor='#d7d7d7'
                                        highlightColor='#c8c8c8'
                                        height={15}
                                        width={150}
                                    />
                                </span>
                            </a>
                        </div>
                    </div>
                </>
            }
            {!isLoading
                && <>
                    {!isMobile && userProfile.picture
                        && <img className='absolute md:relative invisible md:visible border-top-bar-profile w-16 h-16 rounded-full'
                            src={userProfile.picture} alt={intl.formatMessage({
                                defaultMessage: 'User Avatar',
                                id: 'LP_ALT_AVARTAR',
                            })}
                        />
                    }

                    <div className={['flex flex-col pt-4 md:p-6 '].join(' ')}>
                        <div>
                            <span className='font-bold mr-1'>
                                {
                                    intl.formatMessage({
                                        id: 'LP_FULL_NAME',
                                        defaultMessage: 'Full Name:',
                                    })
                                }
                            </span>
                            {name}
                        </div>
                        <div className='mr-3 flex'>
                            <span className='font-bold mr-4'>
                                {
                                    intl.formatMessage({
                                        id: 'LP_EMAIL',
                                        defaultMessage: 'Email:',
                                    })
                                }
                            </span>
                            <span className='break-all'>
                                {email}
                            </span>
                        </div>

                        <div className='flex flex-col md:flex-row mt-3'>
                            <a href={`${env.ssoV1Url}/portal/profile`} className='flex flex-row  place-items-center hover:underline gap-x-2 h-8 mr-10 '>
                                <span className='flex w-auto h-auto content-centerr '> <UserCircleIcon className='fill-icon-grey h-5'/> </span>
                                <span className='font-bold'>
                                    {
                                        intl.formatMessage({
                                            id: 'LP_ACCOUNT_SETTINGS',
                                            defaultMessage: 'Account Settings',
                                        })
                                    }
                                </span>
                                <ChevronRightIcon className='text-gradients-primary-start h-5' />
                            </a>
                            <a href={`${env.ssoV1Url}/portal/security`} className='flex flex-row place-items-center hover:underline gap-x-2 h-8'>
                                <span className='flex w-6 h-6 content-center '> <LockClosedIcon className='fill-icon-grey h-5'/> </span>
                                <span className='font-bold border-b border-transparent group-hover:border-black'>
                                    {
                                        intl.formatMessage({
                                            id: 'LP_ACCOUNT_SUCURITY',
                                            defaultMessage: 'Account Security',
                                        })
                                    }
                                </span>
                                <ChevronRightIcon className='text-gradients-primary-start h-5' />
                            </a>
                        </div>
                    </div>
                </>
            }
        </div>
    );
};

export default ProfileInfomation;
